export const DashboardMenu = {
  Default: {
    name: 'default',
    text: 'Make this my default',
    icon: 'insert-top'
  },
  Delete: {
    name: 'delete',
    text: 'Delete',
    icon: 'delete'
  },
  DraftEdit: {
    name: 'draftedit',
    text: 'Edit draft',
    icon: 'edit'
  },
  DraftCreate: {
    name: 'draftcreate',
    text: 'Create new draft',
    icon: 'plus'
  },
  DraftPublish: {
    name: 'draftpublish',
    text: 'Publish draft',
    icon: 'upload'
  },
  CreateNewDashboard: {
    name: 'createnewdashboard',
    text: 'Copy as new dashboard',
    icon: 'plus'
  },
  CreateNewFromData: {
    name: 'createnewfromdata',
    text: 'Create a new dashboard for this data',
    icon: 'plus'
  },
  Cancel: {
    name: 'cancel',
    text: 'Cancel',
    icon: 'close'
  },
  Discard: {
    name: 'discard',
    text: 'Discard',
    icon: 'delete'
  },
  ExportToPdf: {
    name: 'exporttopdf',
    text: 'Export To PDF',
    icon: 'file-pdf'
  },
  ExportToPptx: {
    name: 'exporttopptx',
    text: 'Export To PPTX',
    icon: 'file-ppt'
  },
  CancelExportToPdf: {
    name: 'cancelexporttopdf',
    text: 'Cancel Export To PDF',
    icon: 'cancel'
  },
  CancelExportToPptx: {
    name: 'cancelexporttopptx',
    text: 'Cancel Export To PPTX',
    icon: 'cancel'
  }
};
